module.exports = __webpack_public_path__ + "static/media/meowing-cat.a781be0c.gif";